import { useOutletContext } from 'react-router-dom';
import { EmployeeList } from '@/components/employees/EmployeeList';
import type { AppShellContext } from '@/components/layout/AppShell';

export function EmployeesPage() {
  const { nip, companyName } = useOutletContext<AppShellContext>();
  return <EmployeeList companyNip={nip} companyName={companyName} />;
}
